import { MdRestaurant as RestaurantsIcon } from 'react-icons/md'
import { ReactComponent as HomeIcon } from 'assets/Icons/Home.svg'
import { ReactComponent as DropIcon } from 'assets/Icons/Place.svg'
import { ReactComponent as IncentivesIcon } from 'assets/Icons/Tag.svg'
import { ReactComponent as ReportsIcon } from 'assets/Icons/Pie-Chart.svg'
import { ReactComponent as SettingsIcon } from 'assets/Icons/Settings.svg'
import { ReactComponent as CompanyIcon } from 'assets/Icons/company.svg'
import { SideNavItemProps } from 'components/SideNavItem'
import BillingContainer from 'containers/BillingContainer'
import TenantsContainer from 'containers/TenantsContainer'
import { HelpContainer } from 'containers/HelpContainer'
import { IncentiveContainer } from 'containers/IncentiveContainer'
import { IncentivesContainer } from 'containers/IncentivesContainer'
import { MerchantListContainer } from 'containers/MerchantListContainer'
import { MerchantListsContainer } from 'containers/MerchantListsContainer'
import { ProfileContainer } from 'containers/ProfileContainer'
import { TeamContainer } from 'containers/TeamContainer'
import { RouteMap } from 'lib/router'
import ComingSoon from 'views/ComingSoon'
import PMHomeContainer from 'containers/PMHomeContainer'
import NotFound from 'views/NotFound'
import PropertyManagerSettings from 'views/Settings/PropertyManagerSettings'

export const propertyManagerRoutes: RouteMap<SideNavItemProps> = [
  {
    path: '/',
    exact: true,
    component: PMHomeContainer,
    navTitle: 'pmportal.nav.home',
    navIcon: HomeIcon,
  },
  {
    path: '/workspaces/:workspaceId/incentives/:incentivePlanId',
    component: IncentiveContainer,
    breadcrumb: 'pmportal.nav.incentiveDetails',
  },
  {
    path: '/workspaces/:workspaceId/incentives',
    component: IncentivesContainer,
    navTitle: 'pmportal.nav.incentives',
    navIcon: IncentivesIcon,
    breadcrumb: 'pmportal.nav.incentives',
    featureFlag: 'hera_incentive_plans',
  },
  {
    path: '/workspaces/:workspaceId/restaurants/lists/:listId',
    component: MerchantListContainer,
    routes: [
      {
        path: '/workspaces/:workspaceId/restaurants/lists/:listId/edit',
        breadcrumb: 'pmportal.nav.listConfiguration',
      },
      {
        path: '/workspaces/:workspaceId/restaurants/lists/:listId/share',
        breadcrumb: 'pmportal.nav.listDetails',
      },
    ],
  },
  {
    path: '/workspaces/:workspaceId/restaurants',
    component: MerchantListsContainer,
    routes: [
      {
        path: '/workspaces/:workspaceId/restaurants/network',
        breadcrumb: 'pmportal.nav.restaurants',
      },
      {
        path: '/workspaces/:workspaceId/restaurants/lists',
        breadcrumb: 'pmportal.nav.restaurants',
      },
    ],
    navTitle: 'pmportal.nav.restaurants',
    navIcon: RestaurantsIcon,
  },
  {
    path: '/workspaces/:workspaceId/tenants',
    component: TenantsContainer,
    navTitle: 'pmportal.nav.companies',
    navIcon: CompanyIcon,
    featureFlag: 'hera_workspace_companies_enabled',
  },
  {
    path: '/workspaces/:workspaceId/reports',
    render: () => (
      <ComingSoon
        title="pmportal.reports.title"
        description="pmportal.reports.description"
      />
    ),
    navTitle: 'pmportal.nav.reports',
    navIcon: ReportsIcon,
    statusBadge: 'comingSoon',
  },
  {
    path: '/workspaces/:workspaceId/drop',
    render: () => (
      <ComingSoon
        title="pmportal.drop.title"
        description="pmportal.drop.description"
      />
    ),
    navTitle: 'pmportal.nav.drop',
    navIcon: DropIcon,
    statusBadge: 'comingSoon',
  },
  {
    path: '/workspaces/:workspaceId/settings/help',
    component: HelpContainer,
    breadcrumb: 'pmportal.nav.help',
  },
  {
    path: '/workspaces/:workspaceId/settings/billing',
    component: BillingContainer,
    breadcrumb: 'pmportal.nav.billing',
  },
  {
    path: '/workspaces/:workspaceId/settings/history',
    render: () => (
      <ComingSoon
        title="pmportal.history.title"
        description="pmportal.history.description"
      />
    ),
    breadcrumb: 'pmportal.nav.history',
  },
  {
    path: '/workspaces/:workspaceId/settings/team',
    component: TeamContainer,
    breadcrumb: 'pmportal.nav.team',
  },
  {
    path: '/workspaces/:workspaceId/settings/profile',
    component: ProfileContainer,
    breadcrumb: 'pmportal.nav.myProfile',
  },
  {
    path: '/workspaces/:workspaceId/settings',
    component: PropertyManagerSettings,
    navTitle: 'pmportal.nav.settings',
    navIcon: SettingsIcon,
    breadcrumb: 'pmportal.nav.settings',
  },
  {
    path: '*',
    component: NotFound,
  },
]
